import React, { lazy } from 'react';
import { MapPinIcon, MountainIcon } from 'lucide-react';
import { CompanyPageLayout } from '../components/CompanyPageLayout';
const team = [{
  name: 'Nima Sherpa',
  role: 'Mountain Operations Lead',
  place: 'Solukhumbu',
  image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=900&q=85',
  note: 'Two decades of guiding experience across Nepal’s high trails.'
}, {
  name: 'Sushma Karki',
  role: 'Travel Designer',
  place: 'Kathmandu',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=900&q=85',
  note: 'Turns practical details into journeys that feel personal and unhurried.'
}, {
  name: 'Rajan Gurung',
  role: 'Community Partnerships',
  place: 'Pokhara',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=900&q=85',
  note: 'Works alongside village hosts and local teams across every route.'
}, {
  name: 'Lhakpa Tamang',
  role: 'Trek Leader',
  place: 'Langtang',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=900&q=85',
  note: 'Brings a calm, generous pace to longer journeys in the mountains.'
}];
export function ExploreOurTeam() {
  return <CompanyPageLayout eyebrow="Our team" title="People who know the route by heart." intro="From first questions in Kathmandu to the last trail morning, our team brings local knowledge, practical care, and a deep respect for the places that welcome us." data-id="element-501">
      <section className="px-5 py-20 sm:px-8 sm:py-28 lg:px-12" data-id="element-502">
        <div className="mx-auto max-w-[1180px]" data-id="element-503">
          <div className="grid gap-8 border-b border-[#cfd3c8] pb-12 lg:grid-cols-[0.7fr_1.3fr]" data-id="element-504">
            <MountainIcon className="h-8 w-8 text-[#4f8057]" aria-hidden="true" data-id="element-505" />
            <p className="max-w-2xl text-xl leading-9 text-[#40564a]" data-id="element-506">
              We are planners, guides, hosts, and local partners. What connects
              us is a belief that the best journeys are built through careful
              listening and shared expertise.
            </p>
          </div>
          <div className="mt-12 grid gap-x-7 gap-y-12 sm:grid-cols-2" data-id="element-507">
            {team.map(member => <article key={member.name} className="border-b border-[#cfd3c8] pb-7" data-id="element-508">
                <img src={member.image} alt={`Portrait of ${member.name}, ${member.role}`} className="h-80 w-full object-cover sm:h-96" loading="lazy" data-id="element-509" />
                <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.18em] text-[#4f8057]" data-id="element-510">
                  {member.role}
                </p>
                <div className="mt-2 flex flex-wrap items-baseline justify-between gap-3" data-id="element-511">
                  <h2 className="font-serif text-3xl" data-id="element-512">{member.name}</h2>
                  <p className="flex items-center gap-1 text-sm text-[#718074]" data-id="element-513">
                    <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-514" />
                    {member.place}
                  </p>
                </div>
                <p className="mt-3 max-w-lg leading-7 text-[#52635a]" data-id="element-515">
                  {member.note}
                </p>
              </article>)}
          </div>
        </div>
      </section>
    </CompanyPageLayout>;
}